import { type ComponentProps, useMemo } from 'react'

import { ButtonRadioGroup } from '@/components/common/Button'
import { InputWithLabel } from '@/components/common/Input'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { REC_ROLE_LABELS, type RecRoleType } from '@/defs/rec'
import { galleryActions } from '@/store/gallery'
import { useReduxDispatch } from '@/store/hooks'
import { trackEvent } from '@/utils/analyticsUtil'

import { useGalleryGroups } from '../../GalleryGroupsProvider/GalleryGroupsProvider'

import styles from './GalleryControlsRole.module.scss'

type Props = {
  variant?: ComponentProps<typeof InputWithLabel>['variant']
}

export const GalleryControlsRole = ({ variant }: Props) => {
  const dispatch = useReduxDispatch()
  const { hasMultipleRoles, role, roles } = useGalleryGroups()

  const options = useMemo(
    () =>
      roles.map((c) => ({
        isSelected: c === role,
        label: <IconWithLabel iconBefore={REC_ROLE_LABELS[c].icon}>{REC_ROLE_LABELS[c].label}</IconWithLabel>,
        value: c,
      })),
    [role, roles],
  )

  // NOTE: Only needed when the groupby mixes roles within a group
  if (!hasMultipleRoles) return null

  const onSelect = (v: RecRoleType) => {
    dispatch(galleryActions.setRole(v))
    trackEvent({ action: 'gallery_role_submit', category: 'cardlists', label: v })
  }

  return (
    <div className={styles.container}>
      <InputWithLabel label='Card Role' variant={variant}>
        <ButtonRadioGroup as='button' onSelect={onSelect} options={options} shadow='none' size='sm' textStyle='none' />
      </InputWithLabel>
    </div>
  )
}
